import { Avatar, Box, Button, Divider, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import BookingApi from "../../API/Apis/BookingApi";
import NotAuthorisedPage from "../notAuthorisedPage";
import { BookingGetters } from "../../store/onlineBooking/getters";
import { t } from "i18next";
import BookingDetalisListSideNavigation from "../../components/Layouts/ReservationsCard/BookingDetalisListSideNavigation";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { AppStandardButton } from "../../components/UI/AppButtons";
import { createTheme } from "@mui/material/styles";
import { formatTheme } from "../../config/MuiColorThemes";
import CollapsibleNavbar from "../../components/Layouts/ReservedAreaDashboard/CollapseNavbar";

export function Profile() {
  const appSettings = BookingGetters?.getAppSettings();
  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const isSmallScreen = window.innerWidth <= 768;
  useEffect(() => {
    const id: any = localStorage.getItem("userID");
    BookingApi.getUserProfileByUserId(id).then((e) => {
      setProfileDetails(e.data.onlineUser[0]);
    });
  }, []);
  const [isUpdatingProfilePic, setIsUpdatingProfilePic] =
    useState<boolean>(false);
  const [profileDetails, setProfileDetails] = useState<any>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    userImage: "",
    companyName: "",
    vatNumber: "",
    profile_picture: null as File | null,
  });
  const [isError, setIsError] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  // function handleSubmit(event) {
  //   const id: any = localStorage.getItem("userID");
  //   event.preventDefault();
  //   BookingApi.UpdateUserProfileById(id, profileDetails).then((e) => {
  //     if (e.data.status) {
  //       setModalMessage("User Updated Successfully");
  //       setOpenModal(true);
  //     } else {
  //       setModalMessage("Unable to Update");
  //       setOpenModal(true);
  //       window.location.reload();
  //     }
  //     return e.data;
  //   });
  // }

  function handleSubmit(): void {
    setIsUpdatingProfilePic(true);
    const id = localStorage.getItem("userID");
    if (!id) {
      setModalMessage("User ID not found");
      setOpenModal(true);
      setIsUpdatingProfilePic(false);
      return;
    }
    if (!profileDetails.email || !profileDetails.phoneNumber) {
      setIsError(true);
      setIsUpdatingProfilePic(false);
      return;
    }
    setIsError(false);
    BookingApi.UpdateUserProfileById(id, profileDetails)
      .then((e) => {
        if (e && e.status) {
          setIsUpdatingProfilePic(false);
          setModalMessage("User Updated Successfully");
          // DISPATCH CUSTOM EVENT HERE
          window.dispatchEvent(new Event("userProfileUpdated"));
          BookingApi.getUserProfileByUserId(Number(id)).then((e) => {
            setProfileDetails(e.data.onlineUser[0]);
          });
        } else {
          setIsUpdatingProfilePic(false);
          setModalMessage("Unable to Update");
        }
        setOpenModal(true);
      })
      .catch((err) => {
        setIsUpdatingProfilePic(false);
        console.error("Error in update:", err);
        setModalMessage("Error occurred during update");
        setOpenModal(true);
      });
  }

  const handleReset = (): void => {
    setProfileDetails({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      companyName: "",
      vatNumber: "",
      profile_picture: null as File | null,
    });
  };
  const reservedAreaSection = appSettings && {
    ...appSettings,
    reservedArea: true,
  };
  const [showReserve, setShowReserve] = useState<boolean>(
    !!appSettings?.reservedArea
  );
  useEffect(() => {
    BookingApi.getAppSetting().then((e) => {
      setShowReserve(e.reservedArea);
    });
  }, [showReserve]);

  const handlePhoneNo = (event) => {
    setProfileDetails({ ...profileDetails, phoneNumber: event.target.value });
  };
  const handleFirstName = (event) => {
    setProfileDetails({ ...profileDetails, firstName: event.target.value });
  };
  const handleLastName = (event) => {
    setProfileDetails({ ...profileDetails, lastName: event.target.value });
  };
  const handleCompanyName = (event) => {
    setProfileDetails({ ...profileDetails, companyName: event.target.value });
  };
  const handleVatNumber = (event) => {
    setProfileDetails({ ...profileDetails, vatNumber: event.target.value });
  };
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const requestOnClose = () => {
    setOpenModal(false);
    setModalMessage("");
  };
  const istabletScreen = window.innerWidth > 768 && window.innerWidth < 1300;

  const userInitials =
    `${profileDetails?.firstName?.[0] || ""}${
      profileDetails?.lastName?.[0] || ""
    }`.toUpperCase() ||
    (profileDetails?.companyName &&
      profileDetails.companyName[0].toUpperCase());

  const getImageSrc = (img) => {
    if (!img) return null;
    return img.startsWith("data:image") ? img : `data:image/png;base64,${img}`;
  };
  const hasCustomImage = Boolean(
    profileDetails.userImage ||
      profileDetails.profile_picture_base64 ||
      profileDetails.profile_picture
  );

  const primaryColor = dynamicTheme?.palette?.primary?.main || "#2cb133";

  const avatarSrc = hasCustomImage
    ? profileDetails.userImage ||
      getImageSrc(profileDetails.profile_picture_base64) ||
      profileDetails.profile_picture
    : undefined;

  /* Hidden file input — rendered once, shared by both layouts */
  const fileInputJSX = (
    <input
      type="file"
      accept="image/png, image/jpeg"
      className="hidden"
      ref={fileInputRef}
      name="profile_picture"
      onChange={(e) => {
        const file = e?.target?.files?.[0];
        if (file) {
          if (file.type !== "image/png" && file.type !== "image/jpeg") {
            alert("Only PNG & JPEG files are allowed.");
            e.target.value = "";
            return;
          }
          setProfileDetails({
            ...profileDetails,
            userImage: URL.createObjectURL(file),
            profile_picture: file,
          });
        }
      }}
    />
  );

  return (
    <div
      className="flex-row md:flex"
      style={{ backgroundColor: "#f5f5f5", minHeight: "100vh" }}
    >
      {/* Sidebar — desktop only */}
      {reservedAreaSection && !isSmallScreen && !istabletScreen && (
        <div style={{ width: "260px", flexShrink: 0, alignSelf: "stretch" }}>
          <BookingDetalisListSideNavigation />
        </div>
      )}

      {/* Collapsible navbar — mobile / tablet */}
      {reservedAreaSection && (isSmallScreen || istabletScreen) && (
        <CollapsibleNavbar callFrom="showProfile" />
      )}

      {/* Main content */}
      {reservedAreaSection ? (
        <div
          style={{
            flex: 1,
            padding: isSmallScreen ? "12px" : "",
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* White card — fills the entire right area */}
          <div
            style={{
              backgroundColor: "#fff",
              padding: isSmallScreen ? "20px 16px" : "50px 48px",
              flex: 1,
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            }}
          >
            {/* Page heading */}
            <p
              style={{
                fontSize: isSmallScreen ? "22px" : "26px",
                fontWeight: 700,
                color: "#222",
                margin: 0,
                lineHeight: 1.2,
                paddingLeft: isSmallScreen ? "" : "20px",
              }}
            >
              {t("Edit Profile")}
            </p>
            <p
              style={{
                fontSize: "14px",
                color: "#9ca3af",
                margin: "6px 0 24px",
                paddingLeft: isSmallScreen ? "" : "20px",
              }}
            >
              {t("You can edit your details and account information here.")}
            </p>

            {isUpdatingProfilePic ? (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  height: "60vh",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress />
              </Box>
            ) : isSmallScreen ? (
              /* ── MOBILE layout ── */
              <>
                {fileInputJSX}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "16px",
                  }}
                >
                  <label style={{ cursor: "pointer" }}>
                    <Avatar
                      onClick={() => fileInputRef.current?.click()}
                      src={avatarSrc}
                      sx={{
                        width: 72,
                        height: 72,
                        bgcolor: "#9ca3af",
                        color: "#fff",
                        fontSize: "22px",
                        fontWeight: 400,
                      }}
                    >
                      {!hasCustomImage && (userInitials || "U")}
                    </Avatar>
                  </label>
                </div>

                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label={t("First Name")}
                  value={profileDetails?.firstName}
                  name="firstName"
                  onChange={handleFirstName}
                  InputProps={{ style: { borderRadius: "8px" } }}
                />
                {!profileDetails?.firstName && isError && (
                  <span className="text-red-600 mb-2">
                    Please fill the First Name..!
                  </span>
                )}

                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="lastName"
                  label={t("Surname")}
                  value={profileDetails?.lastName}
                  id="lastName"
                  onChange={handleLastName}
                  InputProps={{ style: { borderRadius: "8px" } }}
                />
                {!profileDetails?.lastName && isError && (
                  <span className="text-red-600 mb-2">
                    Please fill the Last Name..!
                  </span>
                )}

                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label={t("Email")}
                  disabled
                  name="email"
                  value={profileDetails?.email}
                  id="email"
                  InputProps={{ style: { borderRadius: "8px" } }}
                />

                <TextField
                  name="phoneNumber"
                  id="phoneNumber"
                  value={profileDetails?.phoneNumber}
                  margin="normal"
                  required
                  fullWidth
                  label={t("Mobile")}
                  onChange={handlePhoneNo}
                  InputProps={{ style: { borderRadius: "8px" } }}
                />
                {!profileDetails?.phoneNumber && isError && (
                  <span className="text-red-600 mb-2">
                    Please fill the Phone Number ..!
                  </span>
                )}

                <Divider style={{ margin: "24px 0" }} />

                <div style={{ display: "flex", gap: "12px" }}>
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    fullWidth
                    style={{
                      backgroundColor: primaryColor,
                      color: "#fff",
                      borderRadius: "8px",
                      textTransform: "capitalize",
                      fontWeight: 600,
                      padding: "12px 0",
                      fontSize: "15px",
                    }}
                  >
                    {t("Save")}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={handleReset}
                    fullWidth
                    style={{
                      borderColor: "#ccc",
                      color: "#333",
                      borderRadius: "8px",
                      textTransform: "capitalize",
                      fontWeight: 600,
                      padding: "12px 0",
                      fontSize: "15px",
                      backgroundColor: "#fff",
                    }}
                  >
                    {t("Cancel")}
                  </Button>
                </div>
              </>
            ) : (
              /* ── DESKTOP layout: avatar left, fields right ── */
              <>
                {fileInputJSX}
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "flex-start",
                    width: "45%",
                    paddingLeft: "20px",
                  }}
                >
                  {/* Avatar */}
                  <label style={{ cursor: "pointer", flexShrink: 0 }}>
                    <Avatar
                      onClick={() => fileInputRef.current?.click()}
                      src={avatarSrc}
                      sx={{
                        width: 72,
                        height: 72,
                        bgcolor: "#9ca3af",
                        color: "#fff",
                        fontSize: "22px",
                        fontWeight: 400,
                        flexShrink: 0,
                        mt: "52px",
                      }}
                    >
                      {!hasCustomImage && (userInitials || "U")}
                    </Avatar>
                  </label>

                  {/* Fields */}
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      padding: "40px",
                    }}
                  >
                    {profileDetails?.firstName && profileDetails?.lastName && (
                      <>
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          label={t("First Name")}
                          value={profileDetails?.firstName}
                          name="firstName"
                          onChange={handleFirstName}
                          InputProps={{ style: { borderRadius: "8px" } }}
                        />
                        {!profileDetails?.firstName && isError && (
                          <span className="text-red-600 mb-2">
                            Please fill the First Name..!
                          </span>
                        )}

                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          name="lastName"
                          label={t("Surname")}
                          value={profileDetails?.lastName}
                          id="lastName"
                          onChange={handleLastName}
                          InputProps={{ style: { borderRadius: "8px" } }}
                        />
                        {!profileDetails?.lastName && isError && (
                          <span className="text-red-600 mb-2">
                            Please fill the Last Name..!
                          </span>
                        )}
                      </>
                    )}
                    {profileDetails?.companyName && profileDetails?.vatNumber && (
                      <>
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          label={t("Company Name")}
                          value={profileDetails?.companyName || ""}
                          name="companyName"
                          onChange={handleCompanyName}
                          InputProps={{ style: { borderRadius: "8px" } }}
                          InputLabelProps={{ shrink: true }}
                        />
                        {!profileDetails?.companyName && isError && (
                          <span className="text-red-600 mb-2">
                            Please fill the Company Name..!
                          </span>
                        )}
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          label={t("VAT number")}
                          value={profileDetails?.vatNumber || ""}
                          name="vatNumber"
                          onChange={handleVatNumber}
                          InputProps={{ style: { borderRadius: "8px" } }}
                          InputLabelProps={{ shrink: true }}
                        />
                        {!profileDetails?.vatNumber && isError && (
                          <span className="text-red-600 mb-2">
                            Please fill the VAT Number..!
                          </span>
                        )}
                      </>
                    )}

                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      label={t("Email")}
                      disabled
                      name="email"
                      value={profileDetails?.email}
                      id="email"
                      InputProps={{ style: { borderRadius: "8px" } }}
                    />

                    <TextField
                      name="phoneNumber"
                      id="phoneNumber"
                      value={profileDetails?.phoneNumber}
                      margin="normal"
                      required
                      fullWidth
                      label={t("Mobile")}
                      onChange={handlePhoneNo}
                      InputProps={{ style: { borderRadius: "8px" } }}
                    />
                    {!profileDetails?.phoneNumber && isError && (
                      <span className="text-red-600 mb-2">
                        Please fill the Phone Number ..!
                      </span>
                    )}

                    <Divider
                      style={{ margin: "40px 0px", maxWidth: "540px" }}
                    />

                    <div style={{ display: "flex", gap: "12px" }}>
                      <Button
                        variant="contained"
                        onClick={handleSubmit}
                        style={{
                          backgroundColor: primaryColor,
                          color: "#fff",
                          borderRadius: "8px",
                          textTransform: "capitalize",
                          fontWeight: 600,
                          padding: "10px 32px",
                          fontSize: "15px",
                          width: "50%",
                        }}
                      >
                        {t("Save")}
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={handleReset}
                        style={{
                          borderColor: "#ccc",
                          color: "#333",
                          borderRadius: "8px",
                          textTransform: "capitalize",
                          fontWeight: 600,
                          padding: "10px 32px",
                          fontSize: "15px",
                          backgroundColor: "#fff",
                          width: "50%",
                        }}
                      >
                        {t("Cancel")}
                      </Button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      ) : (
        <NotAuthorisedPage />
      )}

      <Dialog
        open={openModal}
        onClose={requestOnClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { borderRadius: "20px" } }}
      >
        <DialogTitle style={{ padding: "3rem" }}>{modalMessage}</DialogTitle>
        <DialogActions>
          <AppStandardButton variant="outlined" onClick={requestOnClose}>
            <p className="text-black normal-case">Close</p>
          </AppStandardButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
